import { Component, ElementRef, ViewContainerRef, ValueProvider, Renderer2, Injector, ChangeDetectionStrategy, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ComponentBase, IComponentBase, applyMixins, ComponentMixins, PropertyCollectionInfo, FormBase, setValue } from '@syncfusion/ej2-angular-base';
import { Switch } from '@syncfusion/ej2-buttons';



export const /** @type {?} */ inputs: string[] = ['checked','cssClass','disabled','enablePersistence','enableRtl','locale','name','offLabel','onLabel','value'];
export const /** @type {?} */ outputs: string[] = ['focus', 'blur', 'change','created','checkedChange'];
export const /** @type {?} */ twoWays: string[] = ['checked'];
/**
 * Represents the Angular Switch Component.
 * ```html
 * <ejs-switch></ejs-switch>
 * ```
 */
@ComponentMixins([ComponentBase, FormBase])
export class SwitchComponent extends Switch implements IComponentBase {
public formCompContext : any;
public formContext : any;
public tagObjects: any;
public checkedChange: any;
public focus: any;
public blur: any;
/**
 * @param {?} ngEle
 * @param {?} srenderer
 * @param {?} viewContainerRef
 * @param {?} injector
 */
constructor(private ngEle: ElementRef,
private srenderer: Renderer2,
private viewContainerRef:ViewContainerRef,
private injector: Injector) {
        super();
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];

        this.registerEvents(outputs);
        this.addTwoWay.call(this, twoWays);
        setValue('currentInstance', this, this.viewContainerRef);
        this.formContext  = new FormBase();
        this.formCompContext  = new ComponentBase();
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnChange(registerFunction: (_: any) => void): void {
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnTouched(registerFunction: () => void): void {
    }
/**
 * @param {?} value
 * @return {?}
 */
public writeValue(value: any): void {
    }
/**
 * @param {?} disabled
 * @return {?}
 */
public setDisabledState(disabled: boolean): void {
    }
/**
 * @return {?}
 */
public ngOnInit() {
        this.formCompContext.ngOnInit(this);
    }
/**
 * @return {?}
 */
public ngAfterViewInit(): void {
        this.formContext.ngAfterViewInit(this);
    }
/**
 * @return {?}
 */
public ngOnDestroy(): void {
        this.formCompContext.ngOnDestroy(this);
    }
/**
 * @return {?}
 */
public ngAfterContentChecked(): void {
        
        this.formCompContext.ngAfterContentChecked(this);
    }
public registerEvents: (eventList: string[]) => void;
public addTwoWay: (propList: string[]) => void;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ejs-switch',
    inputs: inputs,
    outputs: outputs,
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SwitchComponent),
            multi: true
        }
    ],
    queries: {

    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: ViewContainerRef, },
{type: Injector, },
];
}

function SwitchComponent_tsickle_Closure_declarations() {
/** @type {?} */
SwitchComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SwitchComponent.ctorParameters;
/** @type {?} */
SwitchComponent.prototype.formCompContext;
/** @type {?} */
SwitchComponent.prototype.formContext;
/** @type {?} */
SwitchComponent.prototype.tagObjects;
/** @type {?} */
SwitchComponent.prototype.checkedChange;
/** @type {?} */
SwitchComponent.prototype.focus;
/** @type {?} */
SwitchComponent.prototype.blur;
/** @type {?} */
SwitchComponent.prototype.registerEvents;
/** @type {?} */
SwitchComponent.prototype.addTwoWay;
/** @type {?} */
SwitchComponent.prototype.ngEle;
/** @type {?} */
SwitchComponent.prototype.srenderer;
/** @type {?} */
SwitchComponent.prototype.viewContainerRef;
/** @type {?} */
SwitchComponent.prototype.injector;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
